module.exports = __webpack_public_path__ + "img/0S6A0136.37a6b3ff.jpg";